import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

interface LanguageSwitcherProps {
  frPath: string;
  enPath: string;
}

export const LanguageSwitcher = ({ frPath, enPath }: LanguageSwitcherProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isEnglish = location.pathname.endsWith('-en');
  
  return (
    <div className="flex items-center gap-1 bg-muted/50 rounded-lg p-1">
      <Globe className="h-4 w-4 text-muted-foreground ml-2" />
      <Button
        variant={!isEnglish ? "secondary" : "ghost"}
        size="sm"
        onClick={() => navigate(frPath)}
        className="h-7 px-3 text-xs font-medium"
      >
        FR
      </Button>
      <Button
        variant={isEnglish ? "secondary" : "ghost"}
        size="sm"
        onClick={() => navigate(enPath)}
        className="h-7 px-3 text-xs font-medium"
      >
        EN
      </Button>
    </div>
  );
};
